import { coursesApi } from '@/features/editor/coursesApi'
import { useAppSelector } from '@/store/hooks'

/**
 * Сервер принял запись, а перечитывание курса ещё не началось: RTK откладывает инвалидацию, пока
 * летит любой другой запрос (зонд `/moderation` идёт около секунды). Без этого признака контрол
 * освобождался между ответом на запись и второй загрузкой. Курса в кеше нет — перечитывать нечего.
 */
export const useCourseRereadQueued = (courseId: number, writtenAt: number): boolean => {
  const query = useAppSelector(coursesApi.endpoints.getEditorCourse.select(courseId))
  return !query.isUninitialized && writtenAt > (query.startedTimeStamp ?? 0)
}
